import { FC } from 'react';
import { selectedDiagnosticReportsFilter } from '../../redux/reducers/filterDiagnosticReport';
import { PreloadedQuery } from 'react-relay';
import { DiagnosticsCompletedStudentsQuery } from '../../graphQLOperations/__generated__/DiagnosticsCompletedStudentsQuery.graphql';
import { DiagnosticReportCards } from './DiagnosticReportCards';
import { useAppSelector } from '../../redux/hooks';
import { Button } from 'primereact/button';
import { ArrowUpRight } from 'lucide-react';
import { Divider } from 'primereact/divider';
import { DiagnosticsStatusByClassReportQuery } from '../../graphQLOperations/__generated__/DiagnosticsStatusByClassReportQuery.graphql';
import { useNavigate } from 'react-router-dom';

interface Props {
  completedQueryRef: PreloadedQuery<DiagnosticsCompletedStudentsQuery, Record<string, unknown>> | null | undefined;
  notCompletedQueryRef: PreloadedQuery<DiagnosticsCompletedStudentsQuery, Record<string, unknown>> | null | undefined;
  inProgressQueryRef: PreloadedQuery<DiagnosticsStatusByClassReportQuery, Record<string, unknown>> | null | undefined;
}

export const DiagnosticsReport: FC<Props> = ({ completedQueryRef, notCompletedQueryRef, inProgressQueryRef }) => {
  const navigate = useNavigate();
  const reportFilters = useAppSelector(selectedDiagnosticReportsFilter);

  return (
    <div className="tw-w-full">
      <div className="tw-flex tw-flex-row ">
        <div className="tw-flex tw-flex-col tw-justify-between tw-gap-y-2">
          <h1 className="tw-font-sora tw-text-xl tw-text-neutral-950">Class Progress</h1>
          <p className="tw-m-0 tw-font-atkinson tw-text-base tw-text-neutral-700">
            Diagnostic progress across {reportFilters?.classes[0]?.name}
          </p>
        </div>
        <Button
          link
          label="Learn more about the Diagnostic"
          className="tw-text-indigo-600 tw-flex tw-flex-row-reverse tw-gap-x-1 tw-ml-auto"
          icon={<ArrowUpRight size={16} className="tw-text-indigo-600" />}
          onClick={() => navigate('/prep-diagnostics')}
        />
      </div>
      <Divider className="tw-w-full" />

      {completedQueryRef && notCompletedQueryRef && inProgressQueryRef && (
        <DiagnosticReportCards
          completedQueryRef={completedQueryRef}
          notCompletedQueryRef={notCompletedQueryRef}
          inProgressQueryRef={inProgressQueryRef}
        />
      )}
    </div>
  );
};
